import { useEffect, useState } from 'react';
import { fetchFichaCliente } from '../services/clientes';
import type { FichaCliente } from '../types/clientes';

// Ficha bajo demanda: null cuando la llamada no tiene cliente identificado
// (corto-circuito sin fetch). Descarta respuestas obsoletas al cambiar de
// llamada seleccionada (flag de effect vigente).
export function useFichaCliente(idCliente: string | null): {
  ficha: FichaCliente | null;
  cargando: boolean;
} {
  const [ficha, setFicha] = useState<FichaCliente | null>(null);
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    if (!idCliente) {
      setFicha(null);
      setCargando(false);
      return;
    }
    let vigente = true;
    setCargando(true);
    fetchFichaCliente(idCliente)
      .then((f) => {
        if (!vigente) return;
        setFicha(f);
        setCargando(false);
      })
      .catch(() => {
        if (!vigente) return;
        setFicha(null);
        setCargando(false);
      });
    return () => {
      vigente = false;
    };
  }, [idCliente]);

  return { ficha, cargando };
}
